"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = confirmAlert;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _button = _interopRequireDefault(require("../button"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// export const HTML_TYPE = {
//   BUTTON: "button",
//   SUBMIT: "submit",
//   LINK: "link",
// };
var ConfirmAlert = /*#__PURE__*/function (_Component) {
  _inherits(ConfirmAlert, _Component);

  var _super = _createSuper(ConfirmAlert);

  function ConfirmAlert() {
    var _this;

    _classCallCheck(this, ConfirmAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClickButton", function (onClick) {
      if (onClick) onClick();

      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOverlay", function (e) {
      var _this$props = _this.props,
          closeOnClickOutside = _this$props.closeOnClickOutside,
          onCancel = _this$props.onCancel;
      var isClickOutside = e.target === _this.overlay;

      if (closeOnClickOutside && isClickOutside) {
        onCancel();

        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      removeBodyClass();
      removeElementReconfirm();
    });

    return _this;
  }

  _createClass(ConfirmAlert, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          message = _this$props2.message,
          onCancel = _this$props2.onCancel,
          onConfirm = _this$props2.onConfirm;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "confirm-alert-overlay",
        ref: function ref(dom) {
          return _this2.overlay = dom;
        },
        onClick: this.handleClickOverlay
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "confirm-alert"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "confirm-alert-body"
      }, message, /*#__PURE__*/_react.default.createElement("div", {
        className: "confirm-alert-button-group"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        type: _button.default.TYPE.DEFAULT,
        onClick: function onClick() {
          return _this2.handleClickButton(onCancel);
        }
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: function onClick() {
          return _this2.handleClickButton(onConfirm);
        }
      }, "Confirm")))));
    }
  }]);

  return ConfirmAlert;
}(_react.Component);

_defineProperty(ConfirmAlert, "defaultProps", {
  closeOnClickOutside: true,
  onCancel: function onCancel() {
    return null;
  }
});

function createElementReconfirm(properties) {
  var divTarget = document.getElementById("confirm-alert");

  if (divTarget) {
    // Rerender - the mounted ReactConfirmAlert
    (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(ConfirmAlert, properties), divTarget);
  } else {
    // Mount the ReactConfirmAlert component
    document.body.children[0].classList.add("confirm-alert-blur");
    divTarget = document.createElement("div");
    divTarget.id = "confirm-alert";
    document.body.appendChild(divTarget);
    (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(ConfirmAlert, properties), divTarget);
  }
}

function removeElementReconfirm() {
  var target = document.getElementById("confirm-alert");

  if (target) {
    (0, _reactDom.unmountComponentAtNode)(target);
    target.parentNode.removeChild(target);
  }
}

function addBodyClass() {
  document.body.classList.add("confirm-alert-body-element");
}

function removeBodyClass() {
  document.body.classList.remove("confirm-alert-body-element");
}

function confirmAlert(properties) {
  addBodyClass();
  createElementReconfirm(properties);
}

ConfirmAlert.propTypes = {
  message: _propTypes.default.string,
  closeOnClickOutside: _propTypes.default.bool,
  onConfirm: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired
};